import React, { useState, useMemo, useEffect } from 'react';
import Container from 'components/UI/Container';
import Title from 'components/UI/Title';
import Tabs from 'components/UI/Tabs';
import { Calculator } from 'components/Calculator';
import { observer, calculatorState as store } from 'store';
import { createPanelID, createTabID } from 'utils/tabs';
import { withErrorBoundary } from 'components/ErrorBoundary';

import * as styles from './CalculatorWithTabs.module.scss';

const CalculatorWithTabs = ({ title, configs, className }) => {
  const tabsAriaLabel = 'Calculator Tabs';
  const [calcId, setCalcId] = useState(configs[0].config.id);
  const { togglePreview } = store;

  const tabs = useMemo(
    () =>
      configs?.map(({ button: { name, value } }) => {
        return {
          id: value,
          tabLabel: name,
        };
      }),
    [configs],
  );

  const [opacity, setOpacity] = useState({
    '--opacity': 1,
  });

  useEffect(() => {
    configs.forEach(({ config: { id } }) => {
      if (calcId === id) {
        togglePreview(id, true);
      } else {
        togglePreview(id, false);
      }
    });
  }, [calcId]);

  return (
    <Container id="calculator" className={className}>
      <div className={styles.wrapper}>
        <Title>{title}</Title>
        <Tabs
          className={styles.tabsRow}
          filters={tabs}
          active={calcId}
          setActive={setCalcId}
          setStyles={setOpacity}
          tabsAriaLabel={tabsAriaLabel}
        />
        {configs.map(({ button, config }, i) => (
          <div
            key={config.id}
            id={createPanelID(tabsAriaLabel, i)}
            className={styles.calculator}
            style={opacity}
            role="tabpanel"
            tabIndex={0}
            aria-labelledby={createTabID(tabsAriaLabel, i)}
            hidden={calcId !== button.value}
          >
            <Calculator containerId={config.id} config={config} />
          </div>
        ))}
      </div>
    </Container>
  );
};

const ObservedCalculatorWithTabs = observer(CalculatorWithTabs);

ObservedCalculatorWithTabs.displayName = 'CalculatorWithTabs';

export default withErrorBoundary(ObservedCalculatorWithTabs);
